import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import React, { useState } from 'react';
import envConfig from '@nile/home/src/Config/env';
import { SVGIcon } from '@superops/super-icons';

/**
 * Mask component for hiding sensitive data
 * Components handles toggling
 * Accepts maskedData to be displayed on toggle
 */

function MaskedCell(props) {
  const { cell, maskedData, showMasked = false } = props;
  const [show, setShow] = useState(showMasked);

  function onIconClick() {
    setShow(!show);
  }

  /**
   * This function normalizes data coming from table
   */

  function transformData() {
    if (cell) {
      const { actions, field, id } = cell?.column;
      const orginal = cell?.row?.original;
      return {
        data: {
          ...orginal,
          ...field
        }
      };
    }
    return {};
  }

  const { data } = transformData();

  return (
    <div className="flex">
      {(data && data.customFields && data?.customFields[data.name]) ||
      maskedData ? (
        <>
          <div onClick={onIconClick} className="fx center mr-10 ptr">
            {show ? (
              <SVGIcon name="EyeVisible" />
            ) : (
              <SVGIcon name="EyeHidden" />
            )}
          </div>
          <p>
            {show ? data?.customFields[data.name] || maskedData : '**********'}
          </p>
        </>
      ) : (
        <div className="op-05">NA</div>
      )}
    </div>
  );
}

export default MaskedCell;
